import { CourseDetailScreen } from '@/screens/courses-screen/CourseDetailScreen'

export default function CourseDetailRoute() {
  return <CourseDetailScreen />
}
